import {useState, useEffect, useRef} from "react";
import { Chart as ChartJS, ArcElement, Legend, Tooltip, Title, Filler } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { getgraphicsprincs } from "../../../services/graphics";
import { ErrorContext } from "../../../utils/context/error";

function CardService({AreaId, ServicioId}) {
    let TotalTurnos = useRef(0);
    let NombreServi = useRef("");
    let NombreEstado = useRef([]);
    let Color = useRef([]);
    let FillColor = useRef([]);
    const [datos, setDatos] = useState([]);
    const { setShowToast, setOpciones } = ErrorContext();
      
    ChartJS.register(ArcElement, Tooltip, Legend, Title, Filler);
    const data = {
        labels: NombreEstado.current,
          datasets: [
            {
             backgroundColor: Color.current,
             borderColor: FillColor.current,
             borderWidth: 1,
             cutout:'75%',
             offset:5,
             label:'Turnos:', 
             data: datos,
            },
        ],
    };

const options ={
     responsive: true,
     maintainAspectRatio: false,
     parsing: {
        key: 'Cantidad'
      },
      layout:{
        padding: {
          top: 25,
          bottom: 25,
      }
      },
      plugins: {
        tooltip: false,
        legend: {
          display: true,
          position: 'bottom',
          align:'center',
          labels: {
            color: '#6b7280',
            usePointStyle: true,
            pointStyle:'circle',
            boxwidth:10
          }
        },
      }
};

const CenterTextLine ={
    id: 'text',
    beforeDatasetsDraw: function(chart) {
        const { ctx} = chart;
        if (chart.getDatasetMeta(0).data[0])
        {
           ctx.save();
           const textX = chart.getDatasetMeta(0).data[0].x;
           const textY = chart.getDatasetMeta(0).data[0].y;
           
           ctx.font = 'bold 1.25rem';
           ctx.textBaseline = "middle";
           ctx.textAlign='center';
           ctx.fillStyle = "#6b7280";
           ctx.fillText(`Total Turnos:${TotalTurnos.current}`, textX, textY);
        }    
    } 
}
const customDatalabels = {
    id: 'customDatalabels',
    afterDatasetsDraw(chart){
        const {ctx, data} = chart;
        ctx.save();
        data.datasets[0].data.forEach((datapoint, index) => {
            
            const {x, y} = chart.getDatasetMeta(0).data[index].tooltipPosition();
            ctx.font = '13px Roboto';
            ctx.fillStyle = '#ffffff';
            ctx.textAlign = 'center';
            
            ctx.fillText(data.datasets[0].data[index].Cantidad, x, y);
        })
    }  
}
const emptyDoughnut = {
   id: 'emptyDoughnut',
   afterDraw(chart) {
    const {datasets} = chart.data;
    const {chartArea: {left, top, right, bottom}, ctx} = chart;
      if (datasets[0].data.length ===0)
      {
        const centerX = (left + right) / 2;
        const centerY = (top + bottom) / 2;
        const r = Math.min(right - left, bottom - top) / 2;
            
        ctx.beginPath();
        ctx.lineWidth = 6;
        ctx.strokeStyle = '#D8D8D7';
        ctx.arc(centerX, centerY, (r - 18 || 0), 0, 2 * Math.PI);
        ctx.stroke();
         
        ctx.font = 'bold 1.25rem';
        ctx.textBaseline = "middle";
        ctx.textAlign='center';
        ctx.fillStyle = "#6b7280";
        ctx.fillText(`Total Turnos: 0`, centerX,centerY);
      }
      else{
        ctx.lineWidth =  2;
      }
  }
};
const plugins= [ CenterTextLine, customDatalabels, emptyDoughnut ];

useEffect(() => {
    fillGraficaServ();
  },[ServicioId]);

  const fillGraficaServ = async () => {
    const response = await getgraphicsprincs(AreaId, ServicioId);
    if (response) {
         if (response.status === 200) {
           CargarDatos(response.data.data);
         //  NombreArea.current = response.data.area[0].NombreArea; 
         }else{
            const Mensaje = response.message;
            const opc = { type: "Danger", message: Mensaje, active: true };
            setOpciones(opc);
            setShowToast(true);
         }
     }
 };  

 const CargarDatos = (resultado) => {
    let  Turno=[];
    NombreEstado.current=[];
    FillColor.current=[];
    Color.current=[];
    
    let Proceso=0;
    let PorAtender=0;
    let Atendido=0;
    let Pendientes=0; 
    
    TotalTurnos.current =0;
    resultado.forEach((resultados) => {
        const { NombreServ, Cantidad, Estado } = resultados;
        TotalTurnos.current = TotalTurnos.current + Cantidad;
        NombreServi.current = NombreServ;
        //if (!Turnos[Estado]) {
        //    Turnos[Estado] = {
        //        'NombreServ': NombreServ,
        //        'Cantidad': Cantidad,
        //    };
       // }
       if (Estado ==='AC') PorAtender += Cantidad
       else
         if (Estado ==='CE') Atendido += Cantidad
         else
           if (Estado ==='PE') Pendientes += Cantidad
           else
             if (Estado ==='SU') Proceso += Cantidad
      });

    if (PorAtender >0)
    {
     Turno.push({Estado:'PorAtender', Cantidad:PorAtender});
     NombreEstado.current.push('Por Atender | '+PorAtender);
     Color.current.push('rgba(255, 152, 36, 0.5)');
     FillColor.current.push('rgba(255, 152, 36)');
    }

    if (Atendido >0)
    {
      Turno.push({Estado:'Atendidos', Cantidad:Atendido});
      NombreEstado.current.push('Atendidos | '+Atendido);
      Color.current.push('rgba(22, 189, 202, 0.5)');
      FillColor.current.push('rgba(22, 189, 202, 73)');
    }

    if (Pendientes >0)
    {
      Turno.push({Estado:'Pendientes', Cantidad:Pendientes});
      NombreEstado.current.push('Pendientes | '+Pendientes);
      Color.current.push('rgba(203, 67, 53, 0.5)');
      FillColor.current.push('rgba(203, 67, 53)');
    }  

    if (Proceso >0)
    {
       Turno.push({Estado:'Proceso', Cantidad:Proceso});
       NombreEstado.current.push('En Proceso | '+Proceso);
       Color.current.push('rgba(231, 70, 148, 0.5)');
       FillColor.current.push('rgba(231, 70, 148, 73)');
    }
  
  setDatos(Turno);
  
}

return (
    <>
     <div className="flex flex-col w-[10rem] h-[10rem] 2xl:w-[18rem] 2xl:h-[18rem] text-center items-center justify-center">
         <div className="flex text-[1.05rem] font-semibold text-gray-500 leading-none">{NombreServi.current} </div>
           <Doughnut className="Doughnut" key={`dou${AreaId}${ServicioId}`}
           data={data} options={options}  plugins={plugins} />
      </div>
    </>
 );

}
export default CardService;